export enum SLAStateEnum {
  DEACTIVATED = 'deactivated',
  ACTIVATED = 'activated',
}

export type ISLAStateType = 'deactivated' | 'activated';
